import React from "react";
import { Center, Flex, useBreakpointValue, Text, useColorModeValue } from "@chakra-ui/react";
import { FilterButtons } from "./FilterButtons";
import { DealActionButtons } from "./DealActionButtons";

interface ActionButtonsWrapperProps {
  showButtons: "all" | "filter" | "quick_links" | "none";
  size?: "sm" | "md";
  uniqueFilters?: string[];
  highlightedFilters?: string[];
}

export const ActionButtonsWrapper: React.FC<ActionButtonsWrapperProps> = ({
  showButtons,
  size = "sm",
  uniqueFilters = [],
  highlightedFilters = [],
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false, lg: false }, { fallback: "md", ssr: false });
  const isTablet = useBreakpointValue({ base: false, md: true, lg: false }, { fallback: "md", ssr: false });
  const fontColor = useColorModeValue("white", "gray.600");

  return (
    <Center>
      <Flex
        direction="row"
        wrap="wrap"
        gap={2}
        width="100%"
        maxWidth={isMobile ? "100%" : isTablet ? "30rem" : "45rem"}
        alignItems="center"
        justifyContent="center">
        <Text color={fontColor}>Trending:</Text>
        {(showButtons === "filter" || showButtons === "all") && (
          <FilterButtons size="md" uniqueFilters={uniqueFilters} highlightedFilters={highlightedFilters} />
        )}
        {(showButtons === "quick_links" || showButtons === "all") && <DealActionButtons size={size} />}
      </Flex>
    </Center>
  );
};
